if (!customElements.get("nss-modal-wrapper")) {
    customElements.define(
        "nss-modal-wrapper",
        class NSSModalWrapper extends HTMLElement {
            constructor() {
                super();
            }
            connectedCallback() {
                const modal = this.querySelector("nss-modal");

                if (!modal) return;

                if (this.parentElement !== document.body) {
                    // document.body.appendChild(modal);
                }
            }
        }
    );
}
if (!customElements.get("nss-modal")) {
    customElements.define(
        "nss-modal",
        class NSSModal extends HTMLElement {
            constructor() {
                super();

                this.selectors = {
                    trigger: ".js-nss-modal-trigger",
                    closeButton: ".js-nss-modal-close",
                    dialog: ".js-nss-modal-dialog",
                    video: "video"
                };

                this.dataModal = this.getAttribute("data-modal");

                this.closeButton = this.querySelectorAll(this.selectors.closeButton);
                this.dialog = this.querySelector(this.selectors.dialog);
                this.video = this.querySelector(this.selectors.video);

                this.trigger = document.querySelectorAll(
                    `${this.selectors.trigger}[data-modal="${this.dataModal}"]`
                );

                this.allButtons = this.querySelectorAll("a, button");
                this.firstFocusableElement = this.allButtons[0];
                this.lastFocusableElement =
                    this.allButtons[this.allButtons.length - 1];

                this.html = document.documentElement;

                this.init();
            }

            /* ----------------------------
              Video helpers
            ---------------------------- */

            playVideo() {
                if (!this.video) return;

                if (this.video.tagName === "VIDEO") {
                    this.video.play();
                }

                if (this.video.tagName === "IFRAME") {
                    const src = this.video.getAttribute("src");
                    if (!src.includes("autoplay=1")) {
                        const join = src.includes("?") ? "&" : "?";
                        this.video.setAttribute("src", `${src}${join}autoplay=1`);
                    }
                }
            }

            stopVideo() {
                if (!this.video) return;

                if (this.video.tagName === "VIDEO") {
                    this.video.pause();
                    this.video.currentTime = 0;
                }

                if (this.video.tagName === "IFRAME") {
                    const src = this.video.getAttribute("src");
                    this.video.setAttribute("src", src);
                }
            }

            /* ----------------------------
              Modal controls
            ---------------------------- */

            openDialog() {
                // Drop any duplicate modal sharing this data-modal (e.g. a stale
                // portaled copy, or one re-rendered on variant change) so only
                // this single instance ever exists / opens.
                document.querySelectorAll(`nss-modal[data-modal="${this.dataModal}"]`).forEach((m) => {
                    if (m !== this) m.remove();
                });
                // Move to <body> so the backdrop escapes any ancestor stacking
                // context (transform/opacity/filter) that traps its z-index.
                if (this.parentElement !== document.body) {
                    document.body.appendChild(this);
                }
                this.classList.add("is-visible");
                this.html.classList.add("is-nss-modal-show");
                this.playVideo();
                this.closeButton[0]?.focus();
                // Let any inner Swiper re-measure now that it's visible
                window.dispatchEvent(new Event("resize"));
            }

            closeDialog() {
                this.classList.remove("is-visible");
                this.html.classList.remove("is-nss-modal-show");
                this.stopVideo();
                this._lastTrigger?.focus();
            }

            /* ----------------------------
              Init
            ---------------------------- */

            init() {
                // Open — delegated so triggers injected later (e.g. variant
                // switch re-rendering the gallery) still open this modal.
                this._onTriggerClick = (e) => {
                    const trigger = e.target.closest(
                        `${this.selectors.trigger}[data-modal="${this.dataModal}"]`
                    );
                    if (!trigger) return;
                    // Singleton: if more than one modal shares this data-modal
                    // (e.g. a stale portaled copy + a re-rendered one), only the
                    // first in the DOM — the same one the gallery JS populates —
                    // responds, so we never open two modals at once.
                    if (document.querySelector(`nss-modal[data-modal="${this.dataModal}"]`) !== this) return;
                    e.preventDefault();
                    this._lastTrigger = trigger;
                    this.openDialog();
                };
                document.addEventListener("click", this._onTriggerClick);

                // Close button
                this.closeButton.forEach(el => {
                    el.addEventListener("click", () => {
                        this.closeDialog();
                    });
                });

                // Backdrop click
                this.addEventListener("click", (e) => {
                    if (!this.dialog.contains(e.target)) {
                        this.closeDialog();
                    }
                });

                // Escape key
                this.addEventListener("keydown", (e) => {
                    if (e.key === "Escape") {
                        this.closeDialog();
                    }
                });

                // Focus trap
                this.dialog?.addEventListener("keydown", (e) => {
                    if (
                        e.key === "Tab" &&
                        e.shiftKey &&
                        e.target === this.firstFocusableElement
                    ) {
                        e.preventDefault();
                        this.lastFocusableElement.focus();
                    }

                    if (
                        e.key === "Tab" &&
                        !e.shiftKey &&
                        e.target === this.lastFocusableElement
                    ) {
                        e.preventDefault();
                        this.firstFocusableElement.focus();
                    }
                });
            }
        }
    );
}
